<template>
  <v-dialog
    v-if="!hideModal"
    :persistent="false"
    v-model="open"
    ref="dialog"
    transition="custom-dialog-transition"
  >
    <div @click="$emit('resetModal')" class="readme-overlay" />

    <v-card class="readme-card" :class="`readme-card--${itemStatus}`">
      <div class="readme-card__img">
        <v-img
          class="data-iterator-card__image"
          position="top center"
          v-if="item.img || item.screenshot_url"
          :src="item.img || item.screenshot_url"
          width="100%"
          height="391px"
          max-height="391px"
        >
          <template v-slot:placeholder>
            <image-loader />
          </template>
        </v-img>
        <v-divider />
      </div>

      <div class="readme-card__content">
        <div class="d-flex align-center justify-space-between">
          <div class="d-flex align-center">
            <h5>{{ item.title || item.name }}</h5>
            <template v-if="!isNewTheme">
              <div class="activated-chip" v-if="item.status === 'active'">
                {{ $t('message.status.active') }}
              </div>
              <div class="disabled-chip" v-else>{{ $t('message.status.disabled') }}</div>
            </template>
          </div>

          <v-icon
            size="24px"
            @click="$emit('resetModal')"
            color="gray darken-2"
          >
            $close
          </v-icon>
        </div>

        <p
          class="mt-8 mb-6 p-1 base--text description"
          v-html="item.description || $t('message.theme.noDescription')"
        />

        <div class="d-flex align-center justify-space-between flex-wrap">
          <div class="d-flex align-center mt-2">
            <v-btn
              outlined
              color="gray"
              large
              elevation="0"
              @click="$emit('resetModal')"
            >
              <span class="heading--text">{{ $t('button.close') }}</span>
            </v-btn>
          </div>

          <div
            class="d-flex align-center mt-2"
            v-if="typeof rating == 'number'"
          >
            <v-icon
              v-for="item in Math.ceil(rating)"
              :key="item + '-full'"
              size="24"
              class="mr-1"
              :percent="1"
              >$starIcon</v-icon
            >
            <v-icon
              v-for="item in 5 - Math.ceil(rating)"
              :key="item + '-empty'"
              size="24"
              class="mr-1"
              :percent="0"
              >$starIcon</v-icon
            >
            <b class="p-3 ml-2">{{ rating }}/5</b>
          </div>

          <div class="d-flex align-center">
            <v-btn
              color="gray"
              large
              class="mr-4 px-0"
              outlined
              style="min-width: 46px !important"
              elevation="0"
              target="_blank"
              :href="`https://wp-themes.com/${item.slug || item.name}`"
            >
              <v-icon size="24" color="heading" class="mr-0">$eye</v-icon>
            </v-btn>
            <v-btn
              v-if="isNewTheme"
              color="primary"
              large
              elevation="0"
              @click="emit('installItem', item)"
            >
              <v-icon size="16" color="white">$installIcon</v-icon>
              {{ $t('button.install') }}
            </v-btn>
            <template v-else>
              <v-btn
                v-if="item.status !== 'active'"
                color="primary"
                large
                class="mr-4"
                elevation="0"
                @click="emit('action-button-activate', item)"
              >
                <v-icon size="24" color="white">$checkcircle</v-icon>
                {{ $t('button.activate') }}
              </v-btn>
              <v-btn
                color="error"
                large
                elevation="0"
                @click="emit('action-button-update', item)"
              >
                <v-icon size="24" color="white">$update</v-icon>
                {{ $t('button.update') }}
              </v-btn>
            </template>
          </div>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import ImageLoader from "../ImageLoader.vue";

export default {
  components: {
    ImageLoader,
  },
  props: {
    item: Object,
  },
  data() {
    return {
      hideModal: false,
    };
  },
  methods: {
    getThemeUrl: function () {
      if (Object.keys(this.item).length) {
        if (!this.item.name) {
          return (this.item.title || this.item.name || "")
            .toLowerCase()
            .replaceAll(" ", "")
            .replaceAll("-", "");
        } else {
          return this.item.name
            .toLowerCase()
            .replaceAll(" ", "")
            .replaceAll("-", "");
        }
      }
    },
    emit: function (action) {
      this.hideModal = true;

      setTimeout(() => {
        this.$emit(action, this.item);
        this.$nextTick(() => {
          this.$emit("resetModal");
        });
        this.hideModal = false;
      }, 100);
    },
  },
  computed: {
    itemStatus: function () {
      if (this.item.status === "active") {
        if (this.item.update === "none") {
          return "green";
        } else {
          return "red";
        }
      } else {
        return "gray";
      }
    },
    isNewTheme: function () {
      return typeof this.rating == "number";
    },
    rating: function () {
      if (typeof this.item.rating !== "number") {
        return false;
      } else {
        return Math.ceil(this.item.rating / 2) / 10;
      }
    },
    open: {
      get: function () {
        if (Object.keys(this.item).length) {
          this.$store.dispatch("lockBodyScroll");

          return true;
        } else {
          this.$store.dispatch("unlockBodyScroll");

          return false;
        }
      },
      set: function (value) {
        if (!value) {
          this.$store.dispatch("unlockBodyScroll");
          setTimeout(() => {
            this.$emit("resetModal");
          }, 200);
        } else {
          this.$store.dispatch("lockBodyScroll");
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.v-card {
  max-width: 560px !important;
  &.readme-card {
    max-width: 560px !important;
    overflow-y: auto !important;
    overflow-x: hidden !important;
    border-top: 6px solid;

    border-radius: 8px;
    border-color: var(--v-gray-lighten3);
    &--red {
      border-color: var(--v-error-base);
    }
    &--green {
      border-color: var(--v-primary-base);
    }
    .readme-card {
      &__content {
        padding: 32px;
      }
    }
  }
}

.description::v-deep {
  display: block;
  flex-direction: column;
  > p {
    font-size: $font-size-lg;
    line-height: $line-height-lg;
    margin-bottom: 20px;
  }
  ul {
    list-style: disc;
  }

  ul,
  ol {
    margin-bottom: 20px;
    padding-left: 0px;
    > li {
      list-style-position: inside;

      font-size: $font-size-lg;
      line-height: $line-height-lg;
      &:not(:last-child) {
        margin-bottom: 4px;
      }
    }
  }

  blockquote {
    background-color: var(--v-gray-lighten5);
    margin: 20px 0;
    padding: 16px 16px 16px 80px;
    border-radius: 6px;
    position: relative;
    &:before {
      position: absolute;
      content: "";
      width: 45px;
      height: 45px;
      background-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDUiIGhlaWdodD0iNDUiIHZpZXdCb3g9IjAgMCA0NSA0NSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeT0iOCIgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiByeD0iMiIgZmlsbD0iI0RFREVGMSIvPgo8cGF0aCBkPSJNMTcuNSAyMVYzNkMxNy41IDM3LjEwNDYgMTYuNjA0NiAzOCAxNS41IDM4SDgiIHN0cm9rZT0iI0RFREVGMSIgc3Ryb2tlLXdpZHRoPSI1Ii8+CjxyZWN0IHg9IjI1IiB5PSI4IiB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHJ4PSIyIiBmaWxsPSIjREVERUYxIi8+CjxwYXRoIGQ9Ik00Mi41IDIxVjM2QzQyLjUgMzcuMTA0NiA0MS42MDQ2IDM4IDQwLjUgMzhIMzMiIHN0cm9rZT0iI0RFREVGMSIgc3Ryb2tlLXdpZHRoPSI1Ii8+Cjwvc3ZnPgo=");
      left: 16px;
      top: 16px;
    }
    * {
      margin-bottom: 0;
      font-weight: $font-weight-bold;
      font-size: $font-size-base;
      line-height: $line-height-base;
      color: var(--v-gray-darken1);
      a {
        color: var(--v-primary-base);
      }
    }
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-bottom: 16px;
    font-size: $font-size-xlg;
    line-height: $line-height-xlg;
    font-style: normal;
    color: var(--v-text-darken2);
  }
  iframe {
    max-width: 100% !important;
    width: 100% !important;
    margin: 20px 0px;
  }
}

.activated-chip {
  padding: 0px 4px;
  border-radius: 5px;
  font-size: $font-size-sm;
  line-height: $line-height-sm;
  font-weight: $font-weight-bold;
  background-color: var(--v-primary-lighten4);
  color: var(--v-primary-base);
  margin-left: 16px;
  height: 24px;
  display: flex;
  align-items: center;
}
.disabled-chip {
  padding: 0px 4px;
  border-radius: 5px;
  font-size: $font-size-sm;
  line-height: $line-height-sm;
  font-weight: $font-weight-bold;
  background-color: var(--v-gray-lighten5);
  color: var(--v-gray-darken1);
  margin-left: 16px;
  height: 24px;
  display: flex;
  align-items: center;
}

.readme-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
}
.v-application--is-rtl{
    .disabled-chip,
    .activated-chip{
        margin-left: 0px;
        margin-right: 16px;
    }
}
</style>
